import { Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'

export const InvoiceStatus = {
  DRAFT: 'draft',
  ISSUED: 'issued',
  BALANCED: 'balanced',
  CANCELLED: 'cancelled'
} as const

export type MedplumInvoiceStatus =
  | (typeof InvoiceStatus)[keyof typeof InvoiceStatus]
  | string
  | undefined

type CustomerInvoiceStatus = 'unpaid' | 'paid' | 'cancelled' | 'not sent'

interface InvoiceStatusBadgeProps {
  status: MedplumInvoiceStatus
}

const getCustomerInvoiceStatus = (
  status: MedplumInvoiceStatus
): CustomerInvoiceStatus | undefined => {
  switch (status) {
    case InvoiceStatus.DRAFT:
      return 'not sent'
    case InvoiceStatus.ISSUED:
      return 'unpaid'
    case InvoiceStatus.BALANCED:
      return 'paid'
    case InvoiceStatus.CANCELLED:
      return 'cancelled'
    default:
      return undefined
  }
}

const getStyleProps = (status: CustomerInvoiceStatus) => {
  if (status === 'unpaid') {
    return { color: '#C6162C', bg: '#FFF6F6' }
  }
  if (status === 'paid') {
    return { color: '#0D8443', bg: '#F2FFF8' }
  }
  if (status === 'not sent') {
    return { color: '#C24D15', bg: '#FAF3F0' }
  }
  return { color: '#757575', bg: '#F6F6F6' }
}

const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status }) => {
  const customerStatus = useMemo(
    () => getCustomerInvoiceStatus(status),
    [status]
  )

  if (!customerStatus) return null

  const { color, bg } = getStyleProps(customerStatus)

  return (
    <Text
      ml="8px"
      fontSize="12px"
      fontWeight="600"
      lineHeight="1"
      textTransform="uppercase"
      color={color}
      bg={bg}
      borderRadius="2px"
      px="8px"
      py="4px"
      alignSelf="center"
    >
      {customerStatus}
    </Text>
  )
}

export default InvoiceStatusBadge
